import React, { lazy } from 'react';
import type { RouteObject } from 'react-router';
import AccessManagementRoutes from '@@/modules/admin/access-management/AccessManagementRoutesDefinition';
import GlobalAuthProvider from '@@/contexts/GlobalAuthProvider';
import AdminWrapper from '@@/products/admin/layouts/AdminWrapper';
const AdminHome = lazy(() => import('@@/products/admin/pages/AdminHome'));
import NotificationsPage from '@@/modules/admin/notifications/NotificationsPage';
import NotificationsAuthorizer from '@@/modules/admin/notifications/components/NotificationsAuthorizer';

export const ADMIN_ROUTES = {
  HOME: '/admin',
  NOTIFICATIONS: '/admin/notifications',
  ACCESS_MANAGEMENT: {
    BASE: '/admin/access-management',
    ROLES: '/admin/access-management/roles',
    USERS: '/admin/access-management/users'
  }
};

const adminRoutes: RouteObject[] = [
  {
    path: 'admin',
    element: <GlobalAuthProvider />,
    children: [
      {
        element: <AdminWrapper />,
        children: [
          {
            index: true,
            element: <AdminHome />
          },
          {
            element: <NotificationsAuthorizer />,
            children: [{ path: ADMIN_ROUTES.NOTIFICATIONS, element: <NotificationsPage /> }]
          },
          ...AccessManagementRoutes
        ]
      }
    ]
  }
];

export default adminRoutes;
